import type { SVGProps } from 'react'
const LineDragIndicator = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M9 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m1.5 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m6-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M15 20.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineDragIndicator }
